import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/network/CheckModeSwitch.tsx");
